const { createContext } = require("react");

const ItemsDashboardContext = createContext(null);

export default ItemsDashboardContext;